module.exports = __webpack_public_path__ + "static/media/working.50f43f7e.png";